import type { MapViewPresence } from "../types";

export type MapViewPresenceMap = Record<string, MapViewPresence>;

const hasValidView = (view: MapViewPresence) =>
  typeof view.lat === "number" &&
  Number.isFinite(view.lat) &&
  typeof view.lon === "number" &&
  Number.isFinite(view.lon) &&
  typeof view.zoom === "number" &&
  Number.isFinite(view.zoom);

export const buildMapViewPresenceMap = (
  entries: MapViewPresence[]
): MapViewPresenceMap => {
  const next: MapViewPresenceMap = {};
  entries.forEach((entry) => {
    if (!entry?.userId || !hasValidView(entry)) return;
    next[entry.userId] = entry;
  });
  return next;
};

export const applyMapViewPresenceUpdate = (
  current: MapViewPresenceMap,
  update: MapViewPresence
): MapViewPresenceMap => {
  if (!update?.userId || !hasValidView(update)) {
    return current;
  }
  return {
    ...current,
    [update.userId]: update
  };
};

export const filterMapViewPresenceByRoster = (
  current: MapViewPresenceMap,
  activeUserIds: Set<string>
): MapViewPresenceMap => {
  let changed = false;
  const next: MapViewPresenceMap = {};
  Object.entries(current).forEach(([userId, view]) => {
    if (activeUserIds.has(userId)) {
      next[userId] = view;
    } else {
      changed = true;
    }
  });
  return changed ? next : current;
};
